var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(" User id: "+_vm._s(_vm.userId))]),_c('ul',_vm._l((_vm.users),function(user,index){return _c('li',{key:index},[_vm._v(_vm._s(user.id)+" - "+_vm._s(user.email))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }